import { ForwardedRef, forwardRef } from 'react';
import classNames from 'classnames';

import { Props } from './select.type';
import { SelectOption } from './select-option';

export const SelectWithOptions = forwardRef(
  (
    {
      hasError,
      isEmpty,
      selectFontLight,
      options,
      readOnly,
      ...props
    }: Props & { options: { value: string | number; label: string }[] },
    ref: ForwardedRef<HTMLSelectElement>
  ) => {
    return (
      <select
        {...props}
        className={classNames(
          {
            'border-soft focus:border-medium': !hasError,
            'border-critical-no-bg': hasError,
            'cursor-not-allowed bg-tertiary': readOnly,
            'fill-primary': !readOnly,
            'text-tertiary': isEmpty,
            'text-primary': !isEmpty,
            'text-subtitle-m': !selectFontLight,
            'text-body-m': selectFontLight,
          },
          'select w-full py-3 pl-3 pr-8 rounded-md border text-body-m placeholder:text-tertiary focus:outline-hidden focus:ring-0'
        )}
        ref={ref}>
        {options.map((option, index) => (
          <SelectOption key={`option-${index}-${option.value}`} value={option.value} label={option.label} />
        ))}
      </select>
    );
  }
);
